<template>
  <div>
    <h1>Icon 图标</h1>
    <p class="page-desc">语义化的矢量图形。</p>

    <k-row gutter="16">
      <k-col span="24" :xl="{ span: 12 }">
        <demo-viewer title="默认" :code="MR">
          <k-icon />
        </demo-viewer>

        <demo-viewer title="大小" :code="DX">
          <k-icon type="setting" size="40" />
        </demo-viewer>

        <demo-viewer title="可点击" :code="KDJ">
          <k-icon type="adduser" @click="handleClick" size="30" />
        </demo-viewer>
      </k-col>
      <k-col span="24" :xl="{ span: 12 }">
        <demo-viewer title="颜色" :code="YS" desc="color 属性可改变图标颜色">
          <k-icon color="gray" type="edit" size="30" />
          <k-divider type="vertical" />
          <k-icon color="#aaa" type="save" size="30" />
        </demo-viewer>

        <demo-viewer
          title="旋转"
          :code="XZ"
          desc="添加 loop 属性即可让图标处于旋转状态。"
        >
          <k-icon loop type="Loading" size="30" />
        </demo-viewer>
      </k-col>
    </k-row>

    <table class="doc-table">
      <caption>
        <h3>属性 props</h3>
      </caption>
      <thead>
        <tr>
          <th>参数</th>
          <th>说明</th>
          <th>类型</th>
          <th>默认值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>type</td>
          <td>图标名称</td>
          <td>String</td>
          <td>close</td>
        </tr>
        <tr>
          <td>size</td>
          <td>图标的大小(px)</td>
          <td>Number | String</td>
          <td>-</td>
        </tr>
        <tr>
          <td>color</td>
          <td>图标的颜色</td>
          <td>String</td>
          <td>-</td>
        </tr>
      </tbody>
    </table>

    <table class="doc-table">
      <caption>
        <h3>事件 events</h3>
      </caption>
      <thead>
        <tr>
          <th>事件名</th>
          <th>说明</th>
          <th>返回值</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>on-click</td>
          <td>点击时触发</td>
          <td>event</td>
        </tr>
      </tbody>
    </table>

    <h4 class="demo-title">
      <span>所有图标</span>
    </h4>

    <ul class="icon-list">
      <li v-for="(item, idx) in iconList" :key="idx">
        <span>
          <k-icon :type="item" size="40" />
          <span class="icon-name">{{ item }}</span>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      MR: `
  <template>
    <k-icon />
  </template>
      `,
      YS: `
  <template>
    <k-icon color="gray" type="edit" />
    <k-icon color="#aaa" type="save" />
  </template>
      `,
      DX: `
  <template>
    <k-icon type="setting" size="40" />
  </template>
      `,
      XZ: `
  <template>
    <k-icon loop type="Loading" size="30" />
  </template>
      `,
      KDJ: `
  <template>
    <k-icon type="adduser" @click="handleClick" />
  </template>
      `,
      iconList: [
        "Loading",
        "check-circle",
        "CI",
        "Dollar",
        "compass",
        "close-circle",
        "frown",
        "info-circle",
        "left-circle",
        "down-circle",
        "EURO",
        "copyright",
        "minus-circle",
        "meh",
        "plus-circle",
        "play-circle",
        "question-circle",
        "Pound",
        "right-circle",
        "smile",
        "trademark",
        "time-circle",
        "timeout",
        "earth",
        "YUAN",
        "up-circle",
        "warning-circle",
        "sync",
        "transaction",
        "undo",
        "redo",
        "reload",
        "reloadtime",
        "message",
        "dashboard",
        "issuesclose",
        "poweroff",
        "logout",
        "piechart",
        "setting",
        "eye",
        "location",
        "edit-square",
        "export",
        "save",
        "Import",
        "appstore",
        "close-square",
        "down-square",
        "layout",
        "left-square",
        "play-square",
        "control",
        "codelibrary",
        "detail",
        "minus-square",
        "plus-square",
        "right-square",
        "project",
        "wallet",
        "up-square",
        "calculator",
        "interation",
        "check-square",
        "border",
        "border-outer",
        "border-top",
        "border-bottom",
        "border-left",
        "border-right",
        "border-inner",
        "border-verticle",
        "border-horizontal",
        "radius-bottomleft",
        "radius-bottomright",
        "radius-upleft",
        "radius-upright",
        "radius-setting",
        "adduser",
        "deleteteam",
        "deleteuser",
        "addteam",
        "user",
        "team",
        "areachart",
        "linechart",
        "barchart",
        "pointmap",
        "container",
        "database",
        "sever",
        "mobile",
        "tablet",
        "redenvelope",
        "book",
        "filedone",
        "reconciliation",
        "file-exception",
        "filesync",
        "filesearch",
        "solution",
        "fileprotect",
        "file-add",
        "file-excel",
        "file-exclamation",
        "file-pdf",
        "file-image",
        "file-markdown",
        "file-unknown",
        "file-ppt",
        "file-word",
        "file",
        "file-zip",
        "file-text",
        "file-copy",
        "snippets",
        "audit",
        "diff",
        "Batchfolding",
        "securityscan",
        "propertysafety",
        "safetycertificate",
        "insurance",
        "alert",
        "delete",
        "hourglass",
        "bulb",
        "experiment",
        "bell",
        "trophy",
        "rest",
        "USB",
        "skin",
        "home",
        "bank",
        "filter",
        "funnelplot",
        "like",
        "unlike",
        "unlock",
        "lock",
        "customerservice",
        "flag",
        "moneycollect",
        "medicinebox",
        "shop",
        "rocket",
        "shopping",
        "folder",
        "folder-open",
        "folder-add",
        "deploymentunit",
        "accountbook",
        "contacts",
        "carryout",
        "calendar-check",
        "calendar",
        "scan",
        "select",
        "boxplot",
        "build",
        "sliders",
        "laptop",
        "barcode",
        "camera",
        "cluster",
        "gateway",
        "car",
        "printer",
        "read",
        "cloud-server",
        "cloud-upload",
        "cloud",
        "cloud-download",
        "cloud-sync",
        "video",
        "notification",
        "sound",
        "radarchart",
        "qrcode",
        "fund",
        "image",
        "mail",
        "table",
        "idcard",
        "creditcard",
        "heart",
        "block",
        "error",
        "star",
        "gold",
        "heatmap",
        "wifi",
        "attachment",
        "edit",
        "key",
        "api",
        "disconnect",
        "highlight",
        "monitor",
        "link",
        "man",
        "percentage",
        "pushpin",
        "phone",
        "shake",
        "tag",
        "wrench",
        "tags",
        "scissor",
        "mr",
        "share",
        "branches",
        "fork",
        "shrink",
        "arrawsalt",
        "verticalright",
        "verticalleft",
        "right",
        "left",
        "up",
        "down",
        "fullscreen",
        "fullscreen-exit",
        "doubleleft",
        "doubleright",
        "arrowright",
        "arrowup",
        "arrowleft",
        "arrowdown",
        "upload",
        "colum-height",
        "vertical-align-botto",
        "vertical-align-middl",
        "totop",
        "vertical-align-top",
        "download",
        "sort-descending",
        "sort-ascending",
        "fall",
        "swap",
        "stock",
        "rise",
        "indent",
        "outdent",
        "menu",
        "unorderedlist",
        "orderedlist",
        "align-right",
        "align-center",
        "align-left",
        "pic-center",
        "pic-right",
        "pic-left",
        "bold",
        "font-colors",
        "exclaimination",
        "font-size",
        "infomation",
        "line-height",
        "strikethrough",
        "underline",
        "number",
        "italic",
        "code",
        "column-width",
        "check",
        "ellipsis",
        "dash",
        "close",
        "enter",
        "line",
        "minus",
        "question",
        "rollback",
        "small-dash",
        "pause",
        "bg-colors",
        "crown",
        "drag",
        "desktop",
        "gift",
        "stop",
        "fire",
        "thunderbolt",
        "check-circle-fill",
        "left-circle-fill",
        "down-circle-fill",
        "minus-circle-fill",
        "close-circle-fill",
        "info-circle-fill",
        "up-circle-fill",
        "right-circle-fill",
        "plus-circle-fill",
        "question-circle-fill",
        "EURO-circle-fill",
        "frown-fill",
        "copyright-circle-fil",
        "CI-circle-fill",
        "compass-fill",
        "Dollar-circle-fill",
        "poweroff-circle-fill",
        "meh-fill",
        "play-circle-fill",
        "Pound-circle-fill",
        "smile-fill",
        "stop-fill",
        "warning-circle-fill",
        "time-circle-fill",
        "trademark-circle-fil",
        "YUAN-circle-fill",
        "heart-fill",
        "piechart-circle-fil",
        "dashboard-fill",
        "message-fill",
        "check-square-fill",
        "down-square-fill",
        "minus-square-fill",
        "close-square-fill",
        "codelibrary-fill",
        "left-square-fill",
        "play-square-fill",
        "up-square-fill",
        "right-square-fill",
        "plus-square-fill",
        "accountbook-fill",
        "carryout-fill",
        "calendar-fill",
        "calculator-fill",
        "interation-fill",
        "project-fill",
        "detail-fill",
        "save-fill",
        "wallet-fill",
        "control-fill",
        "layout-fill",
        "appstore-fill",
        "mobile-fill",
        "tablet-fill",
        "book-fill",
        "redenvelope-fill",
        "safetycertificate-f",
        "propertysafety-fill",
        "insurance-fill",
        "securityscan-fill",
        "file-exclamation-fil",
        "file-add-fill",
        "file-fill",
        "file-excel-fill",
        "file-markdown-fill",
        "file-text-fill",
        "file-ppt-fill",
        "file-unknown-fill",
        "file-word-fill",
        "file-zip-fill",
        "file-pdf-fill",
        "file-image-fill",
        "diff-fill",
        "file-copy-fill",
        "snippets-fill",
        "batchfolding-fill",
        "reconciliation-fill",
        "folder-add-fill",
        "folder-fill",
        "folder-open-fill",
        "database-fill",
        "container-fill",
        "sever-fill",
        "calendar-check-fill",
        "image-fill",
        "idcard-fill",
        "creditcard-fill",
        "fund-fill",
        "read-fill",
        "contacts-fill",
        "delete-fill",
        "notification-fill",
        "flag-fill",
        "moneycollect-fill",
        "medicinebox-fill",
        "rest-fill",
        "shopping-fill",
        "skin-fill",
        "video-fill",
        "sound-fill",
        "bulb-fill",
        "bell-fill",
        "filter-fill",
        "fire-fill",
        "funnelplot-fill",
        "gift-fill",
        "hourglass-fill",
        "home-fill",
        "trophy-fill",
        "location-fill",
        "cloud-fill",
        "customerservice-fill",
        "experiment-fill",
        "eye-fill",
        "like-fill",
        "lock-fill",
        "unlike-fill",
        "star-fill",
        "unlock-fill",
        "alert-fill",
        "api-fill",
        "highlight-fill",
        "phone-fill",
        "edit-fill",
        "pushpin-fill",
        "rocket-fill",
        "thunderbolt-fill",
        "tag-fill",
        "wrench-fill",
        "tags-fill",
        "bank-fill",
        "camera-fill",
        "error-fill",
        "crown-fill",
        "mail-fill",
        "car-fill",
        "printer-fill",
        "shop-fill",
        "setting-fill",
        "USB-fill",
        "golden-fill",
        "build-fill",
        "boxplot-fill",
        "sliders-fill",
        "ant-cloud",
        "medium",
        "slack",
        "apple",
        "android",
        "sketch",
        "Gitlab",
        "dribbble",
        "Youtube",
        "Gitlab-fill",
        "android-fill",
        "apple-fill",
        "Youtube-fill",
        "github-fill",
        "sketch-circle-fill",
        "slack-circle-fill",
        "sketch-square-fill",
        "slack-square-fill",
        "zoomout",
        "apartment",
        "audio",
        "audio-fill",
        "robot",
        "zoomin",
        "robot-fill",
        "bug-fill",
        "bug",
        "audiostatic",
        "comment",
        "signal-fill",
        "verified",
        "shortcut-fill",
        "videocameraadd",
        "switchuser",
        "whatsapp",
        "appstoreadd",
        "caret-down",
        "backward",
        "caret-up",
        "caret-right",
        "caret-left",
        "fast-backward",
        "forward",
        "fast-forward",
        "search",
        "retweet",
        "login",
        "step-backward",
        "step-forward",
        "swap-right",
        "swap-left",
        "woman",
        "plus",
        "eyeclose-fill",
        "eye-close",
        "clear",
        "collapse",
        "expand",
        "deletecolumn",
        "merge-cells",
        "subnode",
        "rotate-left",
        "rotate-right",
        "insertrowbelow",
        "insertrowabove",
        "table",
        "solit-cells",
        "formatpainter",
        "insertrowright",
        "formatpainter-fill",
        "insertrowleft",
        "translate",
        "deleterow",
        "sisternode"
      ]
    };
  },
  methods: {
    handleClick() {
      this.$Message("Clicked!");
    }
  }
};
</script>
<style lang="less" scoped>
ul.icon-list {
  background-color: #fff;
  overflow: hidden;
  list-style: none;
  padding: 0 !important;
  border: 1px dotted #eaeefb;
  border-radius: 4px;
  li {
    float: left;
    width: 20%;
    text-align: center;
    height: 120px;
    line-height: 120px;
    color: #666;
    font-size: 13px;
    border-right: 1px dotted #eee;
    border-bottom: 1px dotted #eee;
    margin-right: -1px;
    margin-bottom: -1px;

    &:after {
      content: "";
      height: 100%;
    }

    span {
      line-height: normal;
      font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
        Microsoft YaHei, SimSun, sans-serif;
      color: #99a9bf;
      transition: color 0.15s linear;
      svg {
        font-size: 32px;
        margin-bottom: 15px;
        color: #606266;
        transition: color 0.15s linear;
      }
    }

    &:after,
    span {
      display: inline-block;
      vertical-align: middle;
    }

    .icon-name {
      display: block;
      padding: 0 3px;
      height: 1em;
    }
  }
}
</style>
